import type * as React from 'react';
import { put } from '@Domain/Api';
import beneficiaryStaffMembersUpdateFailed, {
	type BeneficiaryStaffMembersUpdateFailedAction,
} from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiaryStaffMembersUpdateFailed';
import beneficiaryStaffMembersUpdated, {
	type BeneficiaryStaffMembersUpdatedAction,
} from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiaryStaffMembersUpdated';
import type UpdateBeneficiaryStaffMembers from '@Application/Beneficiaries/Beneficiaries/Commands/UpdateBeneficiaryStaffMembers';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = BeneficiaryStaffMembersUpdatedAction | BeneficiaryStaffMembersUpdateFailedAction;

export default (command: UpdateBeneficiaryStaffMembers) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// `204`, no body: the mutation is applied to the store from `command`, not from the response.
			await put<void>(
				`${parameters.api.host}/api/facilities/${command.facilityId}/beneficiaries/${command.beneficiaryId}/staff-members`,
				command.toJSON(),
			);

			const action = beneficiaryStaffMembersUpdated(
				{
					nursingStaffMemberId: command.nursingStaffMemberId,
					homeCareStaffMemberId: command.homeCareStaffMemberId,
				},
				command.beneficiaryId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = beneficiaryStaffMembersUpdateFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
